import { EGlueResource } from '../configurations/common';
import { IAddress } from './common.models';

export interface IBusinessRoleAddressResourceAttributes {
  name: string;
  address1: string;
  address2: string;
  address3: string;
  zipCode: string;
  city: string;
  country: string;
  iso2Code: string;
  state: string;
  sapId: string;
  id?: string;
}

export interface IBusinessRoleAddressResource<T> {
  id: string;
  type: T;
  attributes: IBusinessRoleAddressResourceAttributes;
}

export interface ISoldToAddressResource extends IBusinessRoleAddressResource<EGlueResource.SOLD_TO_ADDRESSES> {
}

export interface IShipToAddressResource extends IBusinessRoleAddressResource<EGlueResource.SHIP_TO_ADDRESSES> {
}

export interface IBillToAddressResource extends IBusinessRoleAddressResource<EGlueResource.BILL_TO_ADDRESSES> {
}

export interface IPayerAddressResource extends IBusinessRoleAddressResource<EGlueResource.PAYER_ADDRESSES> {
}

export type ISoldToIncludedResource = IShipToAddressResource|IBillToAddressResource|IPayerAddressResource;

export interface ISoldToAddressResponse {
  data: ISoldToAddressResource;
  included?: ISoldToIncludedResource[];
}

export interface ISoldToAddressesResponse {
  data: ISoldToAddressResource[];
  included?: ISoldToIncludedResource[];
}

export interface ISelectSoldTo {
  name: string;
  id: string;
  value: string;
  correct?: boolean;
}


export const ISoldToToISelectSoldTo: (soldTo: IAddress, message: string) => ISelectSoldTo = (soldTo: IAddress, message: string): ISelectSoldTo => {
  const stateWithComma: string = soldTo.state ? `${soldTo.state},` : '';
  const name: string = soldTo.name ?
    `${soldTo.name} (${getAddressForSoldToAccount(soldTo)}, ${soldTo.city}, ${stateWithComma} ${soldTo.zipCode})` :
    message;
  return {
    name: `${soldTo.sapId} - ${name}`,
    id: soldTo.id ?? '',
    value: soldTo.sapId ?? '',
    correct: !!soldTo.name,
  };
};

export const getAddressForSoldToAccount: (attributes: IBusinessRoleAddressResourceAttributes | IAddress) => string = (attributes: IBusinessRoleAddressResourceAttributes | IAddress): string => {
  const fallbackAddress: string = attributes?.address2
    ? attributes?.address2
    : (attributes?.address3 ?? '');

  return attributes?.address1
    ? attributes?.address1
    : fallbackAddress;
};
